import { GOOGLE_CLIENT_ID } from "store/api/constApi";
import { SettingsValue } from "types/payments";

interface GoogleLoginSettings {
  google_login?: string | null;
}

// "Sign in with Google" shows only when the portal has a Google client ID and
// the cluster's settings are loaded without turning it off. A cluster with no
// google_login value (older API) keeps the button, as before the setting.
export const isGoogleLoginEnabled = (
  settings?: GoogleLoginSettings | null,
  clientId: string | undefined = GOOGLE_CLIENT_ID
) =>
  Boolean(clientId) &&
  Boolean(settings) &&
  settings?.google_login !== SettingsValue.NO;
